import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import Form from '@/form/Form.js'
import Send from '@/form/Send.js'
import Can from '@/mixins/Can.js'
import Pagination from '@/form/Pagination.js'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import CKEditor from '@ckeditor/ckeditor5-vue'
import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
import VueGraph from 'vue-graph'// import Noty from 'noty'
import VueFusionCharts from 'vue-fusioncharts'
import FusionCharts from 'fusioncharts'
import Column2D from 'fusioncharts/fusioncharts.charts'
import FusionTheme from 'fusioncharts/themes/fusioncharts.theme.fusion'
import Pusher from 'pusher-js'
import Vuesax from 'vuesax'
import 'vuesax/dist/vuesax.css'
import VueSilentbox from 'vue-silentbox'
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

Vue.use(VueSilentbox)
Vue.use(VueFusionCharts, FusionCharts, Column2D, FusionTheme)
Vue.use(VueGraph)
Vue.use(Vuesax, {
  // options here
})

// Tell Vue to use the plugin

Vue.component('date-picker', VuePersianDatetimePicker)
Vue.use(CKEditor)
Vue.component('v-select', vSelect)
Vue.config.productionTip = false

Vue.prototype.$form = Form
Vue.prototype.$pagination = Pagination
Vue.prototype.$store = store
Vue.prototype.$can = Can
Vue.prototype.$send = Send
// Pusher.logToConsole = true
Vue.prototype.$pusher = new Pusher('c43cfac30166c4f30d45', {
  encrypted: true,
  cluster: 'ap2'
})
Vue.mixin({
  methods: {
    can (name) {
      return this.$store.getters.access(name)
    }
  }
})
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
